/*globals ga*/
angular.module('zc.zenclerkS')
  .factory('Analytics', Analytics);

Analytics.$inject = ['$log'];
function Analytics($log) {
  const service = {};
  service.initialized = false;

  service.initializeGA = function() {
    if(ZC_CONFIG.GA_TRACKING_ID) {
      let gaJs = $(`
      <script>
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
      ga('create', '${ZC_CONFIG.GA_TRACKING_ID}', 'auto');
      </script>
      `);
      $('body').append(gaJs);
      service.initialized = true;
    }
  };

  service.recordPageview = function(url) {
    if(!service.initialized) {
      return;
    }

    if(!ga) {
      $log.warn('Initialized but no GA found');
      return;
    }
    ga('set', 'page', url);
    ga('send', 'pageview');
  };

  return service;
}




// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/analytics.service.js